import Http from '../http'

export const index = (page, name) => Http.get(`/users?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/users', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/users/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/users/${id}`, { headers: { Authorization: localStorage.token } })
